import { Icon } from "./Icon.tsx";

/** "Project data" menu action icon (ProjectMenu.tsx -> ProjectDataDialog.tsx) — a small spreadsheet/table, for the non-map-object data every project can carry (curves, time series, patterns...). */
export function DataIcon() {
  return (
    <Icon>
      <rect x="3" y="4" width="18" height="16" rx="1" />
      <path d="M3 10h18M9 4v16" />
    </Icon>
  );
}
